import React, {Component} from 'react';
import {
  Row,
  Col,
  Button,
  Form,
  Input,
  InputNumber,
  Checkbox,
  Cascader,
  Spin,
  Menu,
  Select
} from 'antd';
import {app, config} from '../../app';
import {getInsuranceOrgOrderFormDetail, getInsuranceOrgOrderPay, insuranceOrgOrderSubmit} from './insure_org_api';
import icp_png from '../../assets/ICP.jpeg';
import insure_pingan from '../../assets/insure_pingan.png';
import insure_bg from '../../assets/insure_bg.png';
import addressOptions from '../../util/cascader-address-options';

const FormItem = Form.Item;
const Option = Select.Option;

class IZZZBuy extends Component {
  constructor(props) {
    super(props);
    this.state = {
      team_lists: [],
      informData: {},
      insurance_info: [],
      volunteer_info: {},
      data_loading: true,
      is_read: false,
      sel_tab: '0',
      is_invoice: false,
      start_date: '',
      end_date: '',
      team_idno: '',
      file: {}
    };
  }

  async componentDidMount() {
    this._isMounted = true;
    const data = await getInsuranceOrgOrderFormDetail();
    if (data) {
      await this.setData({...data, data_loading: false});
    } else {
      this.props.history.go(-1);
    }
  }

  componentWillUnmount() {
    this._isMounted = false;
  }

  setData = (data) => app.setStateSync(this, data);

  /**
   * 提交
   **/
  handleSubmit = (e) => {
    e.preventDefault();
    this.props.form.validateFieldsAndScroll(async (err, values) => {
      if (!err) {
        if (!this.state.team_idno) {
          app.alert('请先上传【法人注册】信息', 'warn');
          return false;
        }
        if (!this.state.is_read) {
          app.alert('请先详细阅读后，同意并选上已阅读', 'warn');
          return false;
        }
        await this.setData({submit_loading: true});
        const params = {...values};
        if (this.state.sel_tab === '1') {
          params.ins_code = 2;
        } else {
          params.ins_code = 1;
        }
        params.address = params.area.join('') + params.address;
        delete params.area;
        let id = await insuranceOrgOrderSubmit(params);
        if (id) {
          await getInsuranceOrgOrderPay(id, () => {
            this.props.history.push('/insure/orders');
          });
        }
        await this.setData({submit_loading: false});
      }
    });
  };

  render() {//510 80
    let {getFieldDecorator, getFieldValue} = this.props.form, formItemLayout = {
      labelCol: {span: 4},
      wrapperCol: {span: 20}
    };
    let {team_lists, insurance_info, is_invoice, file, start_date, end_date, volunteer_info, data_loading, submit_loading, sel_tab, team_idno} = this.state,
      info = insurance_info.length ? insurance_info[Number(sel_tab)] : {};
    return (
      <div className="insure-buy-page insure-details-page">
        <div className="idp-body idp-zzz">
          <Spin tip="正在加载数据..." spinning={data_loading} size="large">
            <Row type="flex" justify="space-between" align="middle" className="pb1">
              <div className="pb1-img">
                <img src={insure_pingan} alt=""/>
              </div>
              {/*<div className="pb1-text">平安应急救援责任保险</div>*/}
            </Row>
            <div className="pb2">
              <img src={insure_bg} alt=""/>
            </div>
            <div style={{padding: '0 10px', background: '#fff'}}>
              <Menu onClick={(e) => this.setData({sel_tab: e.key})} defaultSelectedKeys={['0']} mode="horizontal"
                    className="pb3">
                {
                  insurance_info.map((ii, i) => (
                    <Menu.Item key={i + ''} style={{width: '50%'}}>{ii.scheme_name}</Menu.Item>
                  ))
                }
              </Menu>
              <Form {...formItemLayout} onSubmit={this.handleSubmit} labelAlign="left">
                <Row type="flex" justify="space-between" align="middle"
                     style={{margin: '20px 0 10px 0', color: '#1890ff', fontWeight: 600, fontSize: 16}}>
                  <Col>保障项目</Col>
                  <Col>保额</Col>
                </Row>
                <Row type="flex" justify="space-between" align="middle" className="pb-item">
                  <Col>{info.name}</Col>
                  <Col>{info.ins_amount}万/人</Col>
                </Row>
                <Row type="flex" justify="space-between" align="middle" className="pb-item">
                  <Col>保险费</Col>
                  <Col>{info.total}元/人</Col>
                </Row>
                <div style={{margin: '20px 0 10px 0'}}><b>投保人</b></div>

                <FormItem className="pb-item" label="姓名/公司名" colon={false}>
                  {getFieldDecorator('teamno', {
                    rules: [
                      {
                        required: true,
                        message: '请选择队伍!',
                      },
                    ],
                  })(
                    <Select showSearch optionFilterProp="children" placeholder="请选择" style={{width: 300}} onChange={(v, o) => this.setData({team_idno: o.props.credit_code})}>
                      {
                        team_lists.map(team => {
                          return (
                            <Option key={team.teamno} credit_code={team.credit_code}>{team.teamname}</Option>
                          );
                        })
                      }
                    </Select>
                  )}
                </FormItem>
                <Row type="flex" justify="space-between" align="middle" className="pb-item">
                  <Col>证件类型</Col>
                  <Col>统一社会信用代码</Col>
                </Row>
                <Row type="flex" justify="space-between" align="middle" className="pb-item">
                  <Col>证件号码</Col>
                  <Col>{team_idno || (<span style={{color: 'red'}}>请先上传【法人注册】信息</span>)}</Col>
                </Row>
                <FormItem className="pb-item" label="手机号" colon={false}>
                  {getFieldDecorator('mobile', {
                    initialValue: volunteer_info.mobile || '',
                    rules: [
                      {
                        required: true,
                        message: '请输入您的手机号!',
                      },
                    ],
                  })(
                    <Input placeholder="请输入您的手机号" style={{width: 300}}/>
                  )}
                </FormItem>
                <FormItem className="pb-item" label="所属地区" colon={false}>
                  {getFieldDecorator('area', {
                    rules: [
                      {
                        required: true,
                        message: '请选择所属地区!',
                      },
                    ],
                  })(
                    <Cascader options={addressOptions} showSearch placeholder="请选择" style={{width: 300, textAlign: 'left'}}/>
                  )}
                </FormItem>
                <FormItem className="pb-item" label="详细地址" colon={false}>
                  {getFieldDecorator('address', {
                    rules: [
                      {
                        required: true,
                        message: '请输入您的地址!',
                      },
                    ],
                  })(
                    <Input.TextArea rows={2} placeholder="请输入您的地址" style={{width: 300}}/>
                  )}
                </FormItem>
                <FormItem className="pb-item" label="邮箱" colon={false}>
                  {getFieldDecorator('email', {initialValue: volunteer_info.email || ''})(
                    <Input placeholder="用于接收电子保单" style={{width: 300}}/>
                  )}
                </FormItem>
                <div style={{margin: '20px 0 10px 0'}}>
                  <b style={{marginRight: 20, color: '#333'}}>被保险人</b>
                  <b>同投保人</b>
                </div>

                <div style={{marginBottom: 10}}><b>发票</b></div>
                <div className="pb4">
                  <div>
                    <Checkbox onChange={(e) => this.setData({is_invoice: e.target.checked})}>电子发票（增值税普通发票）</Checkbox>
                  </div>
                  {
                    is_invoice ? (
                      <FormItem className="pb-item"
                                style={{borderTop: '1px solid #ddd', borderBottom: 'none', marginTop: 10}}
                                label="纳税人识别号" colon={false}>
                        {getFieldDecorator('taxpayer_no', {
                          initialValue: team_idno || null,
                          rules: [
                            {
                              required: true,
                              message: '请输入纳税人识别号!',
                            },
                          ],
                        })(
                          <Input placeholder="请输入纳税人识别号" style={{width: 300}}/>
                        )}
                      </FormItem>) : null
                  }
                </div>
                <div style={{margin: '20px 0 10px 0'}}><b>保险期限</b></div>
                <Row type="flex" justify="space-between" align="middle" className="pb-item">
                  <Col>保险起期</Col>
                  <Col>{start_date}</Col>
                </Row>
                <Row type="flex" justify="space-between" align="middle" className="pb-item"
                     style={{borderBottom: 'none'}}>
                  <Col>保险止期</Col>
                  <Col>{end_date}</Col>
                </Row>
                <div style={{color: 'red'}}>
                  保单下单30分钟后生效，例：2019-10-12 11:00:00下单，保险起期为2019-10-12 11:30:00
                </div>
                <div style={{margin: '20px 0 10px 0'}}><b>投保信息</b></div>
                <Row type="flex" justify="space-between" align="middle" className="pb-item">
                  <Col>队员姓名</Col>
                  <Col>{volunteer_info.name}</Col>
                </Row>
                <Row type="flex" justify="space-between" align="middle" className="pb-item">
                  <Col>身份证号码</Col>
                  <Col>{volunteer_info.idno}</Col>
                </Row>
                <div className="pb-item" style={{textAlign: 'left'}}>
                  <div style={{marginBottom: 10}}>资质证书</div>
                  <div>
                    {
                      (volunteer_info.ppeskills || []).map((ppe, i) => (
                        <div className="bi-zzzs" key={i}>{ppe}</div>
                      ))
                    }
                  </div>
                </div>
                <FormItem className="pb-item" label="现场负责人" colon={false}>
                  {getFieldDecorator('is_head', {
                    rules: [
                      {
                        required: true,
                        message: '请选择!',
                      },
                    ]
                  })(
                    <Select placeholder="请选择" style={{width: 100}}>
                      <Option value={'1'}>是</Option>
                      <Option value={'0'}>否</Option>
                    </Select>
                  )}
                </FormItem>
                {
                  getFieldValue('is_head') ? (
                    <FormItem className="pb-item" label="承保人数（含现场负责人）" colon={false}>
                      {getFieldDecorator('num', {
                        rules: [
                          {
                            required: true,
                            message: '请输入人数!',
                          },
                        ],
                        initialValue: getFieldValue('is_head') !== '1' ? 1 : undefined
                      })(
                        <InputNumber disabled={getFieldValue('is_head') !== '1'} placeholder="请输入人数"
                                     style={{width: 100}}/>
                      )}
                    </FormItem>
                  ) : null
                }
                <Row type="flex" justify="space-between" align="middle" className="pb-item">
                  <Col>总保费</Col>
                  <Col>{(info.total || 0) * (getFieldValue('num') || 1)}元</Col>
                </Row>
                <div style={{paddingTop: 20}}>
                  <Checkbox onChange={(e) => this.setData({is_read: e.target.checked})}>我已详细阅读</Checkbox>
                  <a href={config.imgUrl + file.ins} target="_blank">《保险条款》</a>
                  <a href={config.imgUrl + file.notic} target="_blank">《投保顺知》</a>
                  <a href={config.imgUrl + file.invoice} target="_blank">《发票说明》</a>
                </div>
                <Row style={{padding: '20px 0'}}>
                  <Col span={6}>
                    <Button size="large" onClick={() => this.props.history.go(-1)} block>返回</Button>
                  </Col>
                  <Col span={17} offset={1}>
                    <Button type="primary" size="large" htmlType="submit" loading={submit_loading} block>确认购买</Button>
                  </Col>
                </Row>
              </Form>
            </div>
          </Spin>
          <div className="ib-footer">
            <Row gutter={20}>
              <Col span={12} className="fi-right">版权所有: 北京存心救援队</Col>
              <Col span={12} className="fi-left">技术支持及运营: 奥讯新媒体</Col>
              <Col span={12} className="fi-right">
                <a href="http://www.beian.miit.gov.cn" target="_blank">京ICP备16056531号</a>
              </Col>
              <Col span={12} className="fi-left">
                <a href={icp_png} target="_blank">ICP许可证 粤B2-20051036号</a>
              </Col>
            </Row>
          </div>
        </div>
      </div>
    );
  }
}

export default Form.create()(IZZZBuy);



// WEBPACK FOOTER //
// ./src/routes/insure/IZZZBuy.jsx